import { getWppToken } from "@/services/wppAuth";

const VEEVA_URL = "https://cap.hogarth-labs.com/api/v1/veeva";

export interface VeevaDocument {
    id: number;
    name__v: string;
    format__v: "application/pdf";
    filename__v: string;
    product__v: [string] | null;
    type__v: "Promotional Piece" | "Component" | "Multichannel Slide" | "Reference" | "Content Module";
    status__v: "Draft" | "Approved for Distribution" | "Approved for Use";
    document_creation_date__v: string;
    version_modified_date__v: string;
    version_id: string;
    thumbnialURL: string;
}

export interface VeevaSearchResp {
    documents: VeevaDocument[];
    pagination: {
        page: number;
        maxPages: number;
    };
}

async function veevaApiRequest<T>(url: string) {
    let wppToken: string;

    try {
        wppToken = await getWppToken();

        if (!wppToken) {
            throw new Error("No token received from WPP authentication.");
        }
    } catch (error) {
        throw new Error(`Error fetching WPP token: ${(error as Error).message}`, { cause: error });
    }

    const headers = new Headers({ Authorization: `Bearer ${wppToken}` });
    const resp = await fetch(url, { headers });

    if (resp.status === 401) {
        throw new Error("Unauthorized access. Please check your token.");
    }

    if (!resp.ok) {
        throw new Error(`HTTP error! status: ${resp.status}`);
    }

    return (await resp.json()) as T;
}

export async function getAndSearchVeevaDocument({
    page,
    pageSize = 100,
    query = "",
    sortBy = "version_modified_date__v",
    sortDirection = "asc"
}: {
    page: number;
    pageSize?: number;
    documentType?: string;
    query?: string;
    sortBy?: string;
    sortDirection?: string;
}) {
    const url = `${VEEVA_URL}/documents?page=${page}&limit=${pageSize}&search=${query}&sort=${sortBy}&sortDirection=${sortDirection}`;

    return veevaApiRequest<VeevaSearchResp>(url);
}

interface VeevaSyncResp {
    id: string;
    product_id: string;
    documentName: string;
    fileName: string;
    documentURL: string;
    assetsPaths: [];
}

export async function syncVeevaDocument(docId: number) {
    const url = `${VEEVA_URL}/documents/${docId}/sync`;

    return veevaApiRequest<VeevaSyncResp>(url);
}
